// Import all providers first
import { EditorStateProvider } from './EditorStateContext';
import { UIStateProvider } from './UIStateContext';
import { CollaborationStateProvider } from './CollaborationStateContext';
import { AnnotationsStateProvider } from './AnnotationsStateContext';

// Re-export individual contexts
export { EditorStateProvider, useEditorState } from './EditorStateContext';
export { UIStateProvider, useUIState } from './UIStateContext';
export { CollaborationStateProvider, useCollaborationState } from './CollaborationStateContext';
export { AnnotationsStateProvider, useAnnotationsState } from './AnnotationsStateContext';
export { PreferencesStateProvider, usePreferencesState } from './PreferencesStateContext';

// PreferencesStateProvider is mounted above this, in App(): AppContent itself
// needs the theme, and it is the one that renders this provider.
export const AppStateProvider = ({ children }) => {
  return (
    <EditorStateProvider>
      <UIStateProvider>
        <CollaborationStateProvider>
          <AnnotationsStateProvider>
            {children}
          </AnnotationsStateProvider>
        </CollaborationStateProvider>
      </UIStateProvider>
    </EditorStateProvider>
  );
};
